import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { dataToXLS, getFormattedTime } from '../../../../core/utils'
import { SR_TABLE_COLUMNS } from '../table'
import { useSRContext } from '../../contexts'
import { useSRCalls } from '../../hooks'
import { ExportSomethingDialog } from './export-something.dialog'

export const ExportToXLSBtn = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const { getSRsCall } = useSRCalls()
  const {
    actions: { open },
  } = useModalContext()
  const { tableSelection, search } = useSRContext()
  const from = 'sr'

  const [loading, setLoading] = useState(false)

  const mainExport = async (data) => {
    const fileName = `listado_sr_${getFormattedTime()}.xlsx`
    await dataToXLS(data, SR_TABLE_COLUMNS, combos, intl, from, fileName)
  }

  const handleExportAll = async () => {
    setLoading(true)
    try {
      const { data } = await getSRsCall({
        params: { ...search, _num_x_pagina: 10000, _pagina: 1 },
      })
      await mainExport(data.sr)
    } catch (error) {
      console.error('Error al exportar todos los datos:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    if (!tableSelection?.length) {
      open({
        Component: ExportSomethingDialog,
      })
      return
    }

    setLoading(true)
    try {
      await mainExport(tableSelection)
    } catch (error) {
      console.error('Error al exportar la selección:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ThemeButton
        color="primary"
        labelM="sm"
        onClick={handleExport}
        style={{ marginRight: '1em' }}
        loading={loading}
        disabled={loading}
      >
        {intl.formatMessage(
          { id: 'pages.sr.exportToXLS.exportSelectionBtn.title' },
          { count: tableSelection.length }
        )}
      </ThemeButton>
      <ThemeButton
        color="primary"
        labelM="sm"
        loading={loading}
        disabled={loading}
        onClick={handleExportAll}
      >
        {intl.formatMessage({ id: 'pages.sr.exportToXLS.exportAllBtn.title' })}
      </ThemeButton>
    </>
  )
}
